import { useSelector } from "react-redux";
import Icon from "../../../../../assets/icons";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../primaryComponents";

export const OtherDetails = ({
  itemInfo,
  gRForm,
  isDisabled = false,
  setGRForm = () => {},
  closeModal = () => {},
}) => {
  const { allow_custom_batch_name } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  return (
    <div className={globalStyles.pageColumnGaps}>
      <div
        className={`${globalStyles.cardWithBackground} flex-row justify-content-between card-plain`}
        style={{ gap: "25px" }}
      >
        <div>
          <p className="smallest-text-size">Item:</p>
          <h5 className="mb-0">{itemInfo?.product_name}</h5>
        </div>

        <div style={{ width: "100%", maxWidth: "220px" }}>
          <primaryComponents.InputField
            inputIcon={Icon.barCodeIcon}
            classNames="white"
            placeholder={"Enter barcode"}
            value={gRForm?.items[itemInfo.index]?.barcode}
            isDisabled={isDisabled}
            onChange={({ target: { value } }) => {
              const updatedItems = [...gRForm?.items];
              updatedItems[itemInfo.index].barcode = value;

              setGRForm((prevState) => ({
                ...prevState,
                items: updatedItems,
              }));
            }}
            floatError={false}
          />
        </div>
      </div>

      {allow_custom_batch_name ? (
        <primaryComponents.InputField
          classNames="white"
          label="Batch Name"
          placeholder="Enter batch name"
          value={gRForm?.items[itemInfo.index]?.batch_name}
          isDisabled={isDisabled}
          onChange={({ target: { value } }) => {
            const updatedItems = [...gRForm?.items];
            updatedItems[itemInfo.index].batch_name = value;

            setGRForm((prevState) => ({
              ...prevState,
              items: updatedItems,
            }));
          }}
          floatError={false}
        />
      ) : null}

      <primaryComponents.ItemsInputField
        inputIcon={Icon.barCodeIcon}
        label={`Item Level Tracking (e.g. IMEI Numbers, Tracking numbers, etc). Quantity: ${
          gRForm?.items?.[itemInfo?.index]?.quantity_received || 0
        }`}
        placeholder={
          "Enter or scan each tacking numbers/IMEI number followed by a “comma”. E.g. 12345678901, 2345789012, ..."
        }
        isDisabled={isDisabled}
        items={gRForm?.items?.[itemInfo?.index]?.items_number || []}
        onChange={(value) => {
          const updatedItems = [...gRForm?.items];
          updatedItems[itemInfo.index].items_number =
            updatedItems[itemInfo.index].items_number || [];
          updatedItems[itemInfo.index].items_number.push(value);
          updatedItems[itemInfo.index].quantity_received =
            updatedItems[itemInfo.index]?.items_number?.length;

          setGRForm((prevState) => ({
            ...prevState,
            items: updatedItems,
          }));
        }}
        onRemoveItem={(index) => {
          const updatedItems = [...gRForm?.items];
          updatedItems[itemInfo.index].items_number =
            updatedItems[itemInfo.index].items_number || [];
          updatedItems[itemInfo.index].items_number.splice(index, 1);
          updatedItems[itemInfo.index].quantity_received =
            updatedItems[itemInfo.index]?.items_number?.length;

          setGRForm((prevState) => ({
            ...prevState,
            items: updatedItems,
          }));
        }}
      />

      {!isDisabled ? (
        <primaryComponents.Button
          classNames={"btn btn--primary"}
          onClick={closeModal}
        >
          Done
        </primaryComponents.Button>
      ) : null}
    </div>
  );
};
